import axios from 'axios';
export { apiErrorMessage } from './alianzasApi';

const api = axios.create({
  baseURL: `${(process.env.REACT_APP_API_URL || '/api').replace(/\/$/, '')}/innovation/ai-models/healthcenter`,
  timeout: 125000,
});
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('access_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});
api.interceptors.response.use((response) => response, (error) => {
  if (error?.response?.status === 401) {
    localStorage.removeItem('access_token');
    localStorage.removeItem('user');
    if (window.location.pathname !== '/login') window.location.assign('/login');
  }
  return Promise.reject(error);
});

export const aiModelsApi = {
  configuration: () => api.get('').then((r) => r.data),
  catalog: (adapter) => api.get(`/catalog/${adapter}`).then((r) => r.data),
  save: (usage, selection, revision) => api.put(`/selections/${usage}`, { selection, revision }).then((r) => r.data),
};
